import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { AbstractControl, FormGroup, FormArray, FormControl } from '@angular/forms';
import { startWith, map } from 'rxjs/operators';
import { GlobalService } from '../../_services/global.service';

@Component({
  selector: 'app-doctor-form',
  templateUrl: './doctor-form.component.html',
  styleUrls: ['./doctor-form.component.scss', '../detalhe.component.scss']
})
export class DoctorFormComponent implements OnInit {
  @Input() medicoForm!: FormGroup;
  @Input() isSmartCase!: boolean;
  @Input() isVisibleEnderecoMedico!: boolean;

  @Output() validarEntrada = new EventEmitter<void>();

  public crmFiltrado: any[] = [];
  public nomeMedicoFiltrado: any[] = [];
  public especialidadeFiltrado: string[] = [];

  constructor(public global: GlobalService) {}

  ngOnInit(): void {
    // Nome do médico
    this.medicoForm.get('nome')?.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filterNome(value))
      )
      .subscribe(filtrado => this.nomeMedicoFiltrado = filtrado);

    // CRM
    this.medicoForm.get('matricula')?.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filterCrm(value))
      )
      .subscribe(filtrado => this.crmFiltrado = filtrado);

    // Especialidade (cada input do array)
    this.especialidadeArray.controls.forEach((ctrl, index) => {
      ctrl.valueChanges
        .pipe(
          startWith(''),
          map(value => this._filterEspecialidade(value))
        )
        .subscribe(filtrado => this.especialidadeFiltrado = filtrado);
    });
  }

  // ---------------- FILTROS ----------------
  private _filterNome(value: string): any[] {
    const filterValue = value?.toLowerCase() || '';
    return this.global.listaNomeMedico.filter(option =>
      option.nome.toLowerCase().includes(filterValue) ||
      option.matricula.toLowerCase().includes(filterValue)
    );
  }

  private _filterCrm(value: string): any[] {
    const filterValue = value?.toLowerCase() || '';
    return this.global.listaCRM.filter(option =>
      option.matricula.toLowerCase().includes(filterValue)
    );
  }

  private _filterEspecialidade(value: string): string[] {
    const filterValue = value?.toLowerCase() || '';
    return this.global.listaEspecialidade.filter(option =>
      option.toLowerCase().includes(filterValue)
    );
  }

  // ---------------- GETTERS ----------------
  get telefoneArray(): FormArray {
    return this.medicoForm.get('telefone') as FormArray;
  }

  get especialidadeArray(): FormArray {
    return this.medicoForm.get('especialidade') as FormArray;
  }

  // ---------------- ADICIONAR / REMOVER ----------------
  addTelefone() {
    if (this.telefoneArray.length < 2) {
      this.telefoneArray.push(new FormControl(''));
    }
  }

  removeTelefone(index: number) {
    if (this.telefoneArray.length > 0) {
      this.telefoneArray.removeAt(index);
    }
  }

  addEspecialidade() {
    this.especialidadeArray.push(new FormControl(''));
  }

  addEspecialidadeIndex(index: number) {
    this.especialidadeArray.insert(index + 1, new FormControl(''));
  }

  removeEspecialidade(index: number) {
    if (this.especialidadeArray.length > 1) {
      this.especialidadeArray.removeAt(index);
    }
  }

  // ---------------- SELEÇÃO ----------------
  onMedicoSelecionado(medicoSelecionado: any) {
    this.medicoForm.patchValue({
      nome: medicoSelecionado.nome,
      matricula: medicoSelecionado.matricula,
      email: medicoSelecionado.email,
      rua: medicoSelecionado.rua,
      localidade: medicoSelecionado.localidade,
      telefone: medicoSelecionado.telefone,
      especialidade: medicoSelecionado.especialidade
    });
  }

  verificarAtalho(event: KeyboardEvent, campo: string) {
    let campoToNumber = parseInt(campo, 10);
    if (event.altKey && (event.key === 'e' || event.key === 'E')) {
      this.addEspecialidadeIndex(campoToNumber);
    }
    if (event.altKey && (event.key === 's' || event.key === 'S')) {
      const especialidadeArray = this.medicoForm.get('especialidade') as FormArray;
      if (especialidadeArray.length > 1) {
        this.removeEspecialidade(campoToNumber);
      }
    }
  }

  
    
  public loadChangeDetector() {
    const medicoGroup = this.medicoForm as FormGroup;
    const subscribeFilter = <T>(
      control: AbstractControl | null,
      sourceList: T[],
      filterFn: (item: T, value: string) => boolean,
      callback: (filtered: T[]) => void
    ) => {
      if (!control) return;
      control.valueChanges.subscribe(value => {
        const val = (value || '').toUpperCase();
        callback(sourceList.filter(item => filterFn(item, val)));
      });
    };
    if (medicoGroup) {
      const abreviacoes: Record<string, string> = {
        'AZ': 'ALVAREZ', 'CZ': 'CHAVEZ', 'DZ': 'DOMINGUEZ', 'FZ': 'FERNANDEZ',
        'FS': 'FLORES', 'GA': 'GARCIA', 'GZZ': 'GONZALEZ', 'GTZ': 'GUTIERREZ',
        'HZ': 'HERNANDEZ', 'JZ': 'JIMENEZ', 'MZ': 'MARTINEZ', 'MS': 'MORALES',
        'MO': 'MORENO', 'RZ': 'RAMIREZ', 'RS': 'RAMOS', 'RDZ': 'RODRIGUEZ',
        'RO': 'ROMERO', 'SZ': 'SANCHEZ', 'TS': 'TORRES', 'VS': 'VASQUEZ',
        'VZ': 'VAZQUEZ'
      };
      // Filtrar por matrícula
      subscribeFilter(
        medicoGroup.get('matricula'),
        this.global.listaNomeMedico,
        (item, value) => (item['matricula'] || '').toUpperCase().startsWith(value),
        filtered => this.crmFiltrado = filtered
      );
      // Filtrar por nome
      subscribeFilter(
        medicoGroup.get('nome'),
        this.global.listaNomeMedico,
        (item, valueRaw) => {
          const endsWithSpace = valueRaw?.endsWith(' ') ?? false;
          let value = valueRaw.trim();
          const isNumeric = /^\d+$/.test(value);
          let partes = value.split(' ').filter(Boolean).map(p => abreviacoes[p] || p);
          value = partes.join(' ');
          if (endsWithSpace) partes.push('');

          const nome = (item['nome'] || '').toUpperCase();
          const matricula = (item['matricula'] || '').toUpperCase();
          const partesNome = nome.split(' ').filter(Boolean);

          if (isNumeric && value.length > 0) return matricula === value;
          if (partes.length === 1 && value.length !== 3) return nome.startsWith(value);
          if (partes.length === 1 && value.length === 3) return value.split('').every(l => partesNome.map(p => p[0]).includes(l));
          if (partes.length > 1) return partes.every(p => nome.includes(p));

          return nome.includes(value);
        },
        filtered => this.nomeMedicoFiltrado = filtered
      );
    }
  }
}
